export default {
  toRoute: function(router, route, replace) {
    if (replace) {
      router.replace(route);
    } else {
      router.push(route);
    }
  },
  toLogin: function(router, replace, query) {
    let route = {
      name: 'Login',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  toTicketSellHome: function(router, replace, query) {
    let route = {
      path: 'ticket',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  toBuyTicket: function(router, replace, query) {
    let route = {
      path: 'ticket/buyTicket',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  toOrderConfirm: function(router, replace, query) {
    let route = {
      path: 'orderConfirm',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  toOrderList: function(router, replace, query) {
    let route = {
      path: '/account/ticket-order',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  toOrderDetail: function(router, replace, query) {
    let route = {
      path: '/account/ticket-order-detail',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  toMallOrder: function(router, replace, query) {
    let route = {
      path: '/account/mall-order',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  toGoodsDetail: function(router, replace, query) {
    let route = {
      path: '/account/mall-order-detail',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  toContacts: function(router, replace, query) {
    let route = {
      path: '/account/contacts',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  toNewsList: function(router, replace, query) {
    let route = {
      path: 'news',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  toNewsInfo: function(router, replace, query) {
    let route = {
      path: 'newsDetail',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  toSpotsDetail: function(router, replace, query) {
    let route = {
      path: '/overview/scenic-spots-detail',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  toNoteDetail: function(router, replace, query) {
    let route = {
      path: '/strategy/note-detail',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  toVideoInfo: function(router, replace, query) {
    let route = {
      path: '/strategy/video-detail',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  toPageInfo: function(router, replace, query) {
    let route = {
      path: '/pageDetail',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  FromMallHomeToCart: function(router, replace, query) {
    let route = {
      path: 'mall/cart',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  FormDetailToCart: function(router, replace, query) {
    let route = {
      path: 'cart',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  toDetail: function(router, replace, query) {
    let route = {
      path: 'mall/detail',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
  toSubmitOrder: function(router, replace, query) {
    let route = {
      path: 'submitOrder',
      query: query,
    };
    this.toRoute(router, route, replace);
  },
};
